import { render, staticRenderFns } from "./legacy.vue?vue&type=template&id=7cf62f6c&scoped=true&"
import script from "./legacy.vue?vue&type=script&lang=js&"
export * from "./legacy.vue?vue&type=script&lang=js&"
import style0 from "./legacy.vue?vue&type=style&index=0&id=7cf62f6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf62f6c",
  null
  
)

component.options.__file = "legacy.vue"
export default component.exports